function pricelistsController(DatatableLang, $translate, $scope, WS, $window, $state) {
    'ngInject';

    const vm = this;

    vm.pricelists = [];
    vm.pricelist = {
        pricelist_Code: '',
        pricelist_Name: '',
        date_debut: '',
        date_fin: '',
        produits: []
    };

    vm.get = function () {
        WS.get('pricelistsweb')
            .then(function (response) {
                if (response.status == 200) {
                    vm.pricelists = response.data;

                    $scope.$apply();

                    $('.table').DataTable({
                        destroy: true,
                        "language": DatatableLang
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    vm.show = function () {
        WS.get('pricelistsweb/details/' + $state.params.pricelist_code)
            .then(function (response) {
                if (response.status == 200) {
                    vm.pricelist.produits = response.data;

                    // header info
                    if (response.data.length > 0) {
                        vm.pricelist.pricelist_Code = response.data[0].pricelist_Code;
                        vm.pricelist.pricelist_Name = response.data[0].pricelist_Name;
                        vm.pricelist.date_debut = response.data[0].date_debut;
                        vm.pricelist.date_fin = response.data[0].date_fin;
                    }

                    $scope.$apply();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    vm.ajouterProduit = function () {
        vm.pricelist.produits.push({
            item_Code: '',
            item_Name: '',
            price_HT: 0,
            price_TTC: 0
        });
    };

    vm.removeProduit = function (index) {
        vm.pricelist.produits.splice(index, 1);
    };

    vm.save = function () {

        WS.post('pricelistsweb/create-or-update', vm.pricelist)
            .then(function (response) {

                if (response.data.success == true) {

                    swal(
                        $translate.instant('Succès'),
                        $translate.instant('Pricelist saved successfully'),
                        'success'
                    ).then(function () {
                        $window.location.href = '/pricelists';
                    });

                } else {
                    swal(
                        $translate.instant('Erreur'),
                        $translate.instant(response.data.message),
                        'error'
                    );
                }

            })
            .catch(function (error) {
                console.log(error);
            });
    };

    vm.delete = function (code) {

        swal({
            title: $translate.instant('Supprimer'),
            text: $translate.instant("Voulez-vous supprimer ce pricelist ?"),
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: $translate.instant('Oui'),
            cancelButtonText: $translate.instant('Non'),
        }).then(function () {

            WS.delete('pricelistsweb/' + code)
                .then(function () {

                    swal(
                        $translate.instant('Succès'),
                        $translate.instant('Pricelist supprimé avec succès'),
                        'success'
                    ).then(function () {
                        $window.location.reload();
                    });

                })
                .catch(function () {
                    swal(
                        $translate.instant('Erreur'),
                        $translate.instant('Suppression impossible'),
                        'error'
                    );
                });

        }, function (error) {
            console.log(error);
        });
    };
}

export default {
    name: 'pricelistsController',
    fn: pricelistsController
};
